'use client';

import {
    Button,
    Column,
    Heading,
    Icon,
    Row,
} from 'oddsgate-ds';
import React, { Suspense } from 'react';

import DisplayImage from '@/components/common/DisplayImage/DisplayImage';
import Link from 'next/link';
import NavigationEvents from '@/components/common/NavigationEvents/NavigationEvents';
import { useGlobalContext } from '@/lib/globalContext';

export default function NotFound() {
    const state = useGlobalContext();
    const defaultLang = process.env.NEXT_PUBLIC_DEFAULT_LANG || 'en';
    const lang = state?.lang || defaultLang;
    const homeUrl = lang !== defaultLang ? `/${lang}/` : '/';
    const dict404 = state?.dict?.page404 as Record<string, string> | undefined;

    return (
        <>
            <Suspense>
                <NavigationEvents
                    acf={{ page_style: 'dark', header_absolute: true }}
                />
            </Suspense>
            <div>
                <Row align="center" className="pt-10 pb-10">
                    <Column md={1}></Column>
                    <Column md={6}>
                        <div>
                            <Heading
                                tag="h2"
                                size="h1"
                                className="color-primary50 text-uppercase">
                                {dict404?.preTitle}
                            </Heading>
                            <Heading
                                tag="h1"
                                size="h1"
                                className="color-secondary50 mt-3">
                                {dict404?.title}
                            </Heading>
                            <Heading tag="span" size="h5" className="mt-4">
                                {dict404?.text}
                            </Heading>
                            <Link href={homeUrl}>
                                <Button
                                    variant="secondary"
                                    rightIcon={<Icon icon="icon-forward-arrow" />}
                                    className="mt-5">
                                    {dict404?.button}
                                </Button>
                            </Link>
                        </div>
                    </Column>
                    <Column md={4}>
                        <DisplayImage
                            alt={'Page 404'}
                            url={'/assets/components/404.svg'}
                            width={445}
                            height={775}
                            fill={false}
                        />
                    </Column>
                    <Column md={1}></Column>
                </Row>
            </div>
        </>
    );
}
